export const SURVEY_OTHER_OPTION_ID = "__other__";
export const SURVEY_OTHER_TEXT_MAX_LENGTH = 300;

export function toggleSurveySelection(question, currentSelections = [], optionId) {
  if (question?.type === "single") return [optionId];
  return currentSelections.includes(optionId)
    ? currentSelections.filter((id) => id !== optionId)
    : [...currentSelections, optionId];
}

export function getSurveyQuestionValidation(question, selections = [], otherText = "") {
  if (question?.type === "single" && selections.length !== 1) return "required";
  if (question?.type === "multiple" && selections.length < 1) return "required";
  if (selections.includes(SURVEY_OTHER_OPTION_ID)) {
    const cleanText = String(otherText || "").trim();
    if (!cleanText) return "otherRequired";
    if (cleanText.length > SURVEY_OTHER_TEXT_MAX_LENGTH) return "otherTooLong";
    if (/<[^>]*>/.test(cleanText)) return "otherPlainText";
  }
  return null;
}

export function buildSurveySubmission(answers = {}, otherTexts = {}) {
  const cleanOtherTexts = {};
  for (const [questionId, selections] of Object.entries(answers)) {
    if (Array.isArray(selections) && selections.includes(SURVEY_OTHER_OPTION_ID)) {
      cleanOtherTexts[questionId] = String(otherTexts[questionId] || "").trim();
    }
  }
  return { answers, otherTexts: cleanOtherTexts };
}
